/**
 * Relocate Share Buttons
 */

export const newsPageShare = () => {
  (function ($) {

    if ($('body').is('.page-node-type-news')) {
      // Relocate social media
      if($('#block-bettersocialsharingbuttons').length > 0) {
        let socialMedia = $('#block-bettersocialsharingbuttons').clone();
        $('#block-bettersocialsharingbuttons').remove();
        socialMedia.appendTo('#newsShare');
      }
      
    }


  })(jQuery);
}